import { sendFeedback } from '../../api'
import { call, takeLatest } from 'redux-saga/effects'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'

// action type
export const REQUEST_POST_FEEDBACK = 'rp/feedback/REQUEST_POST_FEEDBACK'

// action creator
export const requestPostFeedback = createFormAction(REQUEST_POST_FEEDBACK)

// sagas
export function* postFeedback({ payload }) {
  yield call(sendFeedback, payload)
}

export function* watchRequestPostFeedback() {
  yield takeLatest(
    REQUEST_POST_FEEDBACK,
    createRequestSaga(sendFeedback, {
      key: 'feedback',
      message: __('Sending feedback'),
      successMessage: __('Feedback sent successfully . Thank you'),
      write: true,
    }),
  )
}

export const sagas = [watchRequestPostFeedback]
